module.exports = __webpack_public_path__ + "img/zyl.a7e10d40.jpg";